import React from 'react';

const inputCls = "p-2 bg-white border border-slate-300 rounded-lg text-slate-800 placeholder-slate-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent";

const FamilyMemberForm = ({ family, onFamilyChange, onAdd, onRemove }) => (
  <div className="space-y-4">
    <div className="flex justify-between items-center">
      <h3 className="text-lg font-semibold text-slate-800">Family Members</h3>
      <button type="button" onClick={onAdd}
        className="px-4 py-2 bg-blue-50 hover:bg-blue-100 text-blue-700 border border-blue-200 rounded-xl font-medium transition-all duration-200">
        + Add Family Member
      </button>
    </div>
    {family.map((fam, index) => (
      <div key={index} className="p-4 bg-slate-50 border border-slate-200 rounded-xl space-y-3">
        <div className="flex gap-3">
          <input type="text" name="name" placeholder="Name" value={fam.name}
            onChange={(e) => onFamilyChange(index, e)}
            required maxLength={100} className={`flex-1 ${inputCls}`} />
          <select name="relation" value={fam.relation} onChange={(e) => onFamilyChange(index, e)}
            className={inputCls}>
            <option value="">Relation</option>
            <option value="S">Son</option>
            <option value="D">Daughter</option>
            <option value="W">Wife</option>
            <option value="H">Husband</option>
            <option value="B">Brother</option>
            <option value="F">Father</option>
            <option value="M">Mother</option>
          </select>
          <select name="gender" value={fam.gender} onChange={(e) => onFamilyChange(index, e)}
            className={inputCls}>
            <option value="">Gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
          <button type="button" onClick={() => onRemove(index)} className="text-red-500 hover:text-red-700 px-3 font-bold">×</button>
        </div>
        <div className="flex gap-3">
          <input type="date" name="date_of_birth" value={fam.date_of_birth || fam.dob || ''}
            onChange={(e) => onFamilyChange(index, e)}
            className={`flex-1 ${inputCls}`} />
          <label className="flex items-center text-slate-600 px-3 bg-white border border-slate-300 rounded-lg cursor-pointer">
            <input
              type="checkbox"
              name="sameHousehold"
              checked={fam.sameHousehold || false}
              onChange={(e) => onFamilyChange(index, { target: { name: 'sameHousehold', value: e.target.checked } })}
              className="mr-2 w-4 h-4 text-blue-600 rounded focus:ring-blue-500"
            />
            Same Household
          </label>
        </div>
      </div>
    ))}
  </div>
);

export default FamilyMemberForm;
